import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GameProvider } from './contexts/GameContext';
import { SpotifyProvider } from './context/SpotifyContext';
import Homepage from './pages/Homepage';
import Setup from './pages/Setup';
import Prepare from './pages/Prepare';
import DjDeck from './pages/DjDeck';
import Scoring from './pages/Scoring';
import ScoreEntry from './pages/ScoreEntry';
import ScoreForm from './pages/ScoreForm';
import Display from './pages/Display';
import SpotifyDashboard from './pages/SpotifyDashboard';
import Events from './pages/Events';
import RoundScoring from './pages/RoundScoring';
import PrintCards from './pages/PrintCards';
import PrintAnswers from './pages/PrintAnswers';
import PrintStartYears from './pages/PrintStartYears';
import PrintScoreSheet from './pages/PrintScoreSheet';
import PrintAllRoundsBooklet from './pages/PrintAllRoundsBooklet';
import PrintRound from './pages/PrintRound';
import MusicBingo from './pages/MusicBingo';
import PubQuiz from './pages/PubQuiz';
import Lingo from './pages/Lingo';
import GameRules from './pages/GameRules';
import Scoreboard from './pages/Scoreboard';
import ParticipantScores from './pages/ParticipantScores';
import ReactieBeheer from './pages/ReactieBeheer';
import HomepageEditor from './pages/HomepageEditor';
import TeamJoin from './pages/TeamJoin';
import TeamView from './pages/TeamView';
import { SpotifyCallback } from './pages/SpotifyCallback';
import CameraQR from './pages/CameraQR';
import AdminLogin from './pages/AdminLogin';
import AdminHome from './pages/AdminHome';
import './App.css';

const isAdminAuthenticated = () => {
  const local = localStorage.getItem('hitster-admin');
  const session = sessionStorage.getItem('hitster-admin');
  return Boolean(local || session);
};

const RequireAdmin: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  return isAdminAuthenticated() ? children : <Navigate to="/" replace />;
};

function App() {
  // Use PUBLIC_URL for basename to support subdirectory deployment
  const basename = process.env.PUBLIC_URL || '';
  
  return (
    <BrowserRouter basename={basename}>
      <SpotifyProvider>
        <GameProvider>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/prepare" element={<RequireAdmin><Prepare /></RequireAdmin>} />
            <Route path="/dj-deck" element={<Navigate to="/remotion-radio" replace />} />
            <Route path="/spotify-dashboard" element={<SpotifyDashboard />} />
            <Route path="/events" element={<Events />} />
            <Route path="/round-scoring/:eventId/:roundId" element={<RoundScoring />} />
            <Route path="/print-cards/:eventId/:roundId" element={<PrintCards />} />
            <Route path="/print-answers/:eventId/:roundId" element={<PrintAnswers />} />
            <Route path="/print-score-sheet/:eventId/:roundId" element={<PrintScoreSheet />} />
            <Route path="/print-score-booklets/:eventId/:roundId" element={<PrintAllRoundsBooklet />} />
            <Route path="/print-start-years/:eventId" element={<PrintStartYears />} />
            <Route path="/print-round/:eventId/:roundId" element={<PrintRound />} />
            <Route path="/music-bingo" element={<MusicBingo />} />
            <Route path="/music-bingo/:eventId" element={<MusicBingo />} />
            <Route path="/music-bingo/:eventId/:roundId" element={<MusicBingo />} />
            <Route path="/hitster-antwoorden/:eventId" element={<MusicBingo />} />
            <Route path="/hitster-antwoorden/:eventId/:roundId" element={<MusicBingo />} />
            <Route path="/pubquiz" element={<PubQuiz />} />
            <Route path="/lingo" element={<Lingo />} />
            <Route path="/lingo/:eventId" element={<Lingo />} />
            <Route path="/lingo/:eventId/:roundId" element={<Lingo />} />
            <Route path="/game-rules/:eventId" element={<GameRules />} />
            <Route path="/scoreboard/:eventId" element={<Scoreboard />} />
            <Route path="/participant-scores" element={<ParticipantScores />} />
            <Route path="/participant-scores/:eventId" element={<ParticipantScores />} />
            <Route path="/reacties-beheer" element={<ReactieBeheer />} />
            <Route path="/homepage-beheer" element={<RequireAdmin><HomepageEditor /></RequireAdmin>} />
            <Route path="/admin" element={<Navigate to="/spotify-dashboard" replace />} />
            <Route path="/scoring" element={<Scoring />} />
            <Route path="/score-entry" element={<ScoreEntry />} />
            <Route path="/score-form" element={<ScoreForm />} />
            <Route path="/display" element={<Display />} />
            <Route path="/remotion-radio" element={<RequireAdmin><DjDeck /></RequireAdmin>} />
            <Route path="/join" element={<TeamJoin />} />
            <Route path="/team/:joinCode" element={<TeamView />} />
            <Route path="/spotify-callback" element={<SpotifyCallback />} />
            <Route path="/camera-qr" element={<CameraQR />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin-home" element={<RequireAdmin><AdminHome /></RequireAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </GameProvider>
      </SpotifyProvider>
    </BrowserRouter>
  );
}

export default App;
